import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

export const getABTest = (testName) =>
  fetchWithCSRFToken("/ajax-ab-test", {
    method: "POST",
    body: JSON.stringify({
      test_name: testName,
      company_id_token: companyToken(),
    }),
  });
export const getABTestWithoutRolling = (testName) =>
  fetchWithCSRFToken("/ajax-ab-test-without-rolling", {
    method: "POST",
    body: JSON.stringify({
      test_name: testName,
      company_id_token: companyToken(),
    }),
  });
